import { useEffect, useState } from 'preact/hooks';
import type { State, Store } from '../state/store';

/** Subscribe a component to the store. Re-renders on any change. */
export function useStore(store: Store): State {
  const [state, setState] = useState<State>(store.get());
  useEffect(() => store.subscribe(setState), [store]);
  return state;
}
